import React from "react";
import Footer$ from "@deosite/sections/Footer";

const Footer = props => (
  <Footer$ bgColor={"blueDarken"} fontColor={"neutral"} {...props} />
);

export default Footer;
